export const Props = () => ({
  //--------------------------------------------------------------------------
  //                                  Ссылка на ресурс
  //--------------------------------------------------------------------------
  link: {
    type: String,
    required: true,
  }
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});